<app-template>
    <app-breadcrumb>
        <li class="breadcrumb-item active">Release Notes</li>
    </app-breadcrumb>
</app-template>